const PROJECT_SPECS = [
  { label: 'Location', value: 'D16 - Bedok / Upper East Coast' },
  { label: 'Address', value: 'Bayshore Rd, Singapore' },
  { label: 'Developer', value: 'SingHaiyi Group / Haiyi Holdings' },
  { label: 'Total Units', value: '515' },
  { label: 'Tenure', value: '99 years' },
  { label: 'Expected TOP', value: 'To be released' },
  { label: 'Project Category', value: 'Highrise Condominium' },
  { label: 'Development Mix', value: '2 blocks of 31 storeys, 9 units core' },
];

export default function ProjectDetailsSection() {
  const scrollToEnquiry = () => {
    document.getElementById('enquiry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="project-details" className="py-12 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Showflat Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 text-sm font-semibold px-4 py-2 rounded-full mb-8">
          <i className="ri-calendar-event-line" />
          Showflat Preview: 11th April 2026
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16">
          {/* Left: Title + Description */}
          <div>
            <h1
              className="text-3xl md:text-5xl font-bold text-[#172C37] mb-6"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Vela Bay
            </h1>

            <div className="text-[#172C37]/80 text-base leading-relaxed space-y-4">
              <p className="font-semibold text-[#172C37] text-sm md:text-base">
                515 UNITS &bull; 1+STUDY TO 5 BEDROOM &bull; MORE THAN 70% SEA FACING
              </p>

              <div className="bg-[#172C37]/5 rounded-xl p-4 md:p-5 space-y-2">
                <p className="font-bold text-[#172C37] text-sm md:text-base">📢 ESTIMATED GUIDE PRICING</p>
                <p className="text-sm md:text-base">🎯 Land Cost: $1,388 psf</p>
                <p className="text-sm md:text-base">🎯 Break-even: ~$2,308psf</p>
                <p className="text-sm md:text-base">🎯 Starting Price at 20% Profit: ~$2,783 psf++</p>
              </div>

              <div className="space-y-2">
                <p className="font-bold text-[#172C37] text-sm md:text-base">📍 Why Vela Bay?</p>
                <ul className="space-y-1 list-none pl-0 text-sm md:text-base">
                  <li>✔ Direct access to Bayshore MRT (TEL)</li>
                  <li>✔ Walking distance to East Coast Park &amp; coastline lifestyle</li>
                  <li>✔ Minutes to Marina Bay, CBD &amp; Orchard via TEL</li>
                </ul>
              </div>

              <p className="text-sm md:text-base">
                <strong className="text-[#172C37]">Vela Bay</strong> is set to become a landmark
                residential enclave in Singapore's East Coast, offering a perfect blend of coastal
                living and urban convenience. Vela Bay promises a serene lifestyle with easy access
                to key amenities and transport links.
              </p>

              <div>
                <p className="font-bold text-[#172C37] uppercase underline mb-2 text-sm md:text-base">The Vision</p>
                <p className="text-sm md:text-base">
                  The architectural design is inspired by luxury yachts gliding across calm waters,
                  capturing the elegance, movement, and serenity of a waterfront lifestyle.
                </p>
              </div>

              <div>
                <p className="font-bold text-[#172C37] uppercase underline mb-2 text-sm md:text-base">The Name</p>
                <p className="text-sm md:text-base">
                  <strong>"Vela"</strong>, derived from Latin for "sails," evokes elegance, motion,
                  and the open sea. <strong>"Bay"</strong> anchors the development to its Bayshore
                  Drive location, highlighting its serene coastal setting.
                </p>
                <p className="mt-2 text-sm md:text-base">
                  <strong>Chinese: 首航</strong> ("Maiden Voyage") — reinforces the project's
                  pioneering identity as the first private residential development on the GLS site
                  within the Bayshore precinct.
                </p>
              </div>
            </div>

            <button
              onClick={scrollToEnquiry}
              className="mt-8 bg-[#172C37] text-white font-bold px-8 py-3 rounded-full hover:opacity-70 transition-opacity cursor-pointer whitespace-nowrap"
            >
              Register Your Interest
            </button>
          </div>

          {/* Right: Project Specs */}
          <div>
            <h3
              className="text-2xl font-bold text-[#172C37] mb-6"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Project Details
            </h3>

            <div className="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2">
              {PROJECT_SPECS.map((spec) => (
                <div key={spec.label} className={['Project Category', 'Development Mix'].includes(spec.label) ? 'sm:col-span-2' : ''}>
                  <p className="text-xs font-bold text-[#172C37]/40 uppercase tracking-wider mb-1">
                    {spec.label}
                  </p>
                  <p className="text-base font-semibold text-[#172C37]">{spec.value}</p>
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="border-t border-[#172C37]/15 my-8" />

            {/* Summary Box */}
            <div className="bg-[#172C37] text-white rounded-2xl p-5 md:p-6 space-y-3">
              <p className="text-lg font-bold tracking-wide" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
                VELA BAY 首航
              </p>
              <p className="text-white/80 text-sm leading-relaxed">
                Captures the spirit of setting sail toward a new horizon — the first private
                residential development at the gateway to the revitalised 60-hectare Bayshore
                waterfront estate.
              </p>
              <ul className="text-sm text-white/80 space-y-1">
                <li>• Direct access to Bayshore MRT station</li>
                <li>• Proximity to East Coast Beach</li>
                <li>• Panoramic views toward the Long Island Project</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
